export default {
  brands: 'brands',
  portfolios: 'portfolios',
  embed: 'embed', // Legacy data. Use discoverViews
  discoverViews: 'discoverViews',
  players: 'players',
  retailerCarts: 'retailerCarts',
  userRoles: 'userRoles',
  productPlayers: 'productPlayers',
  inventoryReport: 'inventoryReport', // Not present in firebase-service mappings
  products_v2: 'products',
  videos: 'videos',
  tracking: 'tracking',
  launchLinkParams: 'launchLinkParams',
  parentCompanies: 'parentCompanies',
  amazonSalesInsightsEnrollments: 'amazonSalesInsightsEnrollments',
  brandStaging_amazon: 'brandStaging',
  brandProductFeed: 'brandProductFeed',
  launchMasterList: 'launchMasterList',
  recentLaunchOptions: 'recentLaunchOptions',
  countryCurrency: 'countryCurrency',
};
